export default __webpack_public_path__ + "media/images/paylogos/color/visa@2x-c8d98b00144472235f39fefd4f39bbe6.png";